import {
  IconAngleRight,
  IconComment,
  IconQuestionCircle,
  IconSearchAlt,
} from '@maia/icons';
import { TaskDto } from '@maia/shared';
import { ActionButton, ActionButtonLink, Badge, Widget } from '@maia/ui';
import { getDifferenceInDaysLabelFromNow, getFullName } from '@maia/utils';

type Props = {
  task: TaskDto;
  onOpen: () => void;
};

export function OpenTaskWidget(props: Props) {
  const { task, onOpen } = props;

  return (
    <Widget
      padding="large"
      title={task.title}
      subtitle={task.description}
      actions={[
        <ActionButton icon={IconSearchAlt} size="small" onPress={onOpen} />,
        <ActionButtonLink
          key={task.guid}
          icon={IconAngleRight}
          size="small"
          to={`/tasks/$guid`}
          params={{ guid: task.guid }}
        />,
      ]}
      {...(task.estimatedEndDate
        ? {
            timestamp: {
              showIcon: true,
              date: getDifferenceInDaysLabelFromNow(task?.estimatedEndDate),
            },
          }
        : {})}
    >
      <Badge
        icon={IconComment}
        label={task.noteCount.toString()}
        spacing="small"
      />
      <Badge
        avatar={{ initials: task.assignee?.initials ?? <IconQuestionCircle /> }}
        label={task.assignee ? getFullName(task.assignee) : 'Niet toegewezen'}
      />
      <Badge
        status={{
          color: task.priority.variant,
          variant: 'square',
        }}
        label={task.priority.label}
      />
      <Badge label={task.status.label} />
    </Widget>
  );
}
